module.exports = __webpack_public_path__ + "img/selo-autorregulacao.d7e0bb46.jpeg";